<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Название</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите название тарифного плана"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'rate-plan-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// RatePlanName.vue?059b3ce8